export default __webpack_public_path__ + "static/media/googleplay.df6ec766.png";